<template>
	<div
		id="app"
		:style="{ backgroundImage: `url(${bgImage})`, }"
	>
		<transition
			v-if="showSplashScreen"
			name="fade"
		>
			<AppSplashScreen />
		</transition>

		<template v-else>
			<AppNav v-if="showNav" />

			<router-view />

			<AppTabs v-if="tableId && showTabs" />
		</template>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import { getValue, setValue } from './services/session'

import AppNav from './components/AppNav.vue'
import AppTabs from './components/AppTabs.vue'
import AppSplashScreen from './components/AppSplashScreen.vue'

const routesWithNav = [
	'categories',
	'menu',
	'orders',
	'waiter',
]

const routesWithTabs = [
	'menu',
	'orders',
	'waiter',
]

function isValidWebUrl (url) {
	const regEx = /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)$/gm

	return regEx.test(url)
}

export default {
	components: {
		AppNav,
		AppTabs,
		AppSplashScreen,
	},

	data () {
		return {
			showSplashScreen: true,
		}
	},

	computed: {
		...mapGetters({
			tableId: 'session/tableId',

			languages: 'languages/languages',
			categories: 'categories/categories',
			masterCategories: 'categories/masterCategories',
		}),

		showNav () {
			return routesWithNav.includes(this.$route.name)
		},

		showTabs () {
			return routesWithTabs.includes(this.$route.name)
				&& (this.client.online_order || this.client.call_a_waiter)
		},

		bgImage () {
			if (!['/categories', '/categories-modal', '/languages'].includes(this.$route.path)) {
				return this.client
				&& this.client.background_image
				&& isValidWebUrl(this.client.background_image)
				&& this.client.background_image
			}
			return ''
		},
	},

	mounted () {
		this.getActiveOrder()
		this.fetchData()

		// window.addEventListener('beforeinstallprompt', this.beforeinstallprompt)
	},

	beforeDestroy () {
		window.removeEventListener('beforeinstallprompt', this.beforeinstallprompt)
	},

	methods: {
		...mapActions({
			getClient: 'client/getClient',

			getLanguages: 'languages/getLanguages',
			updateSelectedLanguage: 'languages/updateSelectedLanguage',

			getCategories: 'categories/getCategories',
			getMasterCategories: 'categories/getMasterCategories',

			setOrder: 'orders/setOrder',
		}),

		async fetchData () {
			this.showSplashScreen = true

			await this.getClient()
			await this.getLanguages()
			await this.getCategories()
			await this.getMasterCategories()

			this.checkSelectedLanguage()

			setTimeout(() => {
				this.showSplashScreen = false
			}, 1500)
		},

		checkSelectedLanguage () {
			const selectedLanguage = getValue('selectedLanguage')

			if (selectedLanguage) {
				this.updateSelectedLanguage(selectedLanguage)
			} else if (this.languages.length === 1) {
				this.selectLanguage(this.languages[0])
			}
		},

		selectLanguage (language) {
			setValue('selectedLanguage', language)

			this.updateSelectedLanguage(language)

			if (['#StayFrappy', 'Chocolate'].includes(this.client.name)) {
				this.$router.push({
					path: '/categories',
				})
			} else {
				this.$router.push({
					path: '/menu',
				})
			}
		},

		getActiveOrder () {
			const activeOrder = getValue('activeOrder')

			if (
				activeOrder
				&& activeOrder.products
				&& activeOrder.products.length
			) this.setOrder(activeOrder)
		},

		beforeinstallprompt (event) {
			event.preventDefault()

			document.querySelector('#install-button').disabled = false
		},
	},
}
</script>

<style lang="scss" scoped>
	@font-face {
		font-family: 'Harrys-Regular';
		src: url('assets/fonts/Harrys-Regular.otf') format('opentype');
	}

	@font-face {
		font-family: 'Futura-Book';
		src: url('assets/fonts/Futura-Book.otf') format('opentype');
	}

	#app {
		min-height: 100vh;
		background-position: center center;
		background-repeat: no-repeat;
		background-size: cover;
		background-attachment: fixed;
	}

	.fade-enter-active, .fade-leave-active {
		transition: opacity .5s;
	}

	.fade-enter, .fade-leave-to {
		opacity: 0;
	}
</style>
